﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿<template>
  <div class="home">
    <!-- 头部渐变背景图 -->
    <div class="header-bg" :style="{ backgroundImage: 'url(' + headerBg + ')' }"></div>

    <!-- 搜索栏（固定顶部；页面滚动后显示纯色底） -->
    <div :class="['search-bar', { scrolled: scrolled }]">
      <div class="search-container" @click="goSearch">
        <svg viewBox="0 0 24 24" class="loc-icon"><path d="M12 2 Q6 2 6 10 Q6 16 12 22 Q18 16 18 10 Q18 2 12 2 Z" fill="none" stroke="#fff" stroke-width="2"/><circle cx="12" cy="10" r="3" fill="none" stroke="#fff" stroke-width="2"/></svg>
        <span class="loc-text">省本级</span>
        <span class="divider"></span>
        <svg viewBox="0 0 24 24" class="search-icon"><circle cx="11" cy="11" r="7" fill="none" stroke="#fff" stroke-width="2"/><path d="M16 16 L21 21" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>
        <span class="placeholder">请输入关键字搜索</span>
      </div>
    </div>

    <van-pull-refresh
      v-model="refreshing"
      :head-height="headHeight"
      :animation-height="headHeight"
      @refresh="onRefresh"
      class="home-pull"
    >
      <!-- 下拉刷新提示 -->
      <template #normal>
        <div class="rf-head">
          <span class="rf-time">最后更新：{{ lastUpdateText }}</span>
        </div>
      </template>
      <template #pulling>
        <div class="rf-head">
          <svg class="rf-arrow" viewBox="0 0 24 24">
            <path d="M12 20 V5" />
            <path d="M5.5 11.5 12 5l6.5 6.5" />
          </svg>
          <div class="rf-col">
            <div class="rf-main">下拉即可刷新</div>
            <div class="rf-time">最后更新：{{ lastUpdateText }}</div>
          </div>
        </div>
      </template>
      <template #loosing>
        <div class="rf-head">
          <svg class="rf-arrow" viewBox="0 0 24 24">
            <path d="M12 20 V5" />
            <path d="M5.5 11.5 12 5l6.5 6.5" />
          </svg>
          <div class="rf-col">
            <div class="rf-main">松开立即刷新</div>
            <div class="rf-time">最后更新：{{ lastUpdateText }}</div>
          </div>
        </div>
      </template>
      <template #loading>
        <div class="rf-head">
          <span class="rf-spinner"></span>
          <div class="rf-col">
            <div class="rf-main">正在刷新...</div>
          </div>
        </div>
      </template>

      <div class="home-body">

    <!-- 快捷功能 -->
    <div class="quick-grid">
      <div
        class="quick-item"
        v-for="item in quickList"
        :key="item.text"
        @click="handleQuickClick(item)"
      >
        <van-icon :name="item.icon" class="quick-icon" color="#fff" :size="quickIconSize" />
        <span class="quick-text">{{ item.text }}</span>
      </div>
    </div>

    <!-- 应用图标区 -->
    <div class="app-grid">
      <div class="app-item" v-for="item in appList" :key="item.text" @click="handleAppClick(item)">
        <img :src="getIcon(item.icon)" class="app-icon" :alt="item.text" />
        <span class="app-text">{{ item.text }}</span>
      </div>
    </div>

    <!-- 轮播图 -->
    <div class="banner">
      <van-swipe class="banner-swipe" :autoplay="3000" :touchable="true" :show-indicators="false">
        <van-swipe-item v-for="(img, idx) in bannerList" :key="idx">
          <img :src="img" class="banner-img" :alt="'banner' + idx" />
        </van-swipe-item>
      </van-swipe>
    </div>

    <!-- 主题服务 -->
    <div class="theme-section">
      <div class="section-title">主题服务</div>
      <div class="service-grid">
        <div v-for="item in themeServices" :key="item.title" class="service-item" @click="handleServiceClick(item)">
          <img :src="getIcon(item.icon)" class="service-icon" :alt="item.title" />
          <div class="service-info">
            <div class="service-title">{{ item.title }}</div>
            <div class="service-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>
      </div><!-- /home-body -->
    </van-pull-refresh>

    <!-- 扫一扫弹窗 -->
    <scan-dialog
      :visible="scanVisible"
      @close="scanVisible = false"
      @success="handleScanSuccess"
    />

    <!-- 二次认证弹窗 -->
    <div class="verify-dialog-mask" v-if="showVerifyDialog" @click="showVerifyDialog = false">
      <div class="verify-dialog" @click.stop>
        <div class="verify-title">提示</div>
        <div class="verify-content">该功能需要进行二次认证</div>
        <div class="verify-btns">
          <button class="verify-btn cancel" @click="showVerifyDialog = false">取消</button>
          <button class="verify-btn confirm" @click="handleVerifyConfirm">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon, Swipe, SwipeItem, Dialog, PullRefresh, Toast } from 'vant'
import 'vant/lib/icon/index.css'
import 'vant/lib/swipe/index.css'
import 'vant/lib/swipe-item/index.css'
import 'vant/lib/dialog/index.css'
import 'vant/lib/pull-refresh/index.css'
import 'vant/lib/toast/index.css'
import ScanDialog from '@/components/ScanDialog.vue'
import { navigateWithLoading } from '@/utils/loading'

const iconContext = require.context('@/assets/icons', false, /\.png$/)
const icons = {}
iconContext.keys().forEach(key => {
  const name = key.replace(/^\.\//, '').replace(/\.png$/, '')
  icons[name] = iconContext(key)
})

const headerBg = require('@/assets/bg/home-header.png')

export default {
  name: 'Home',
  components: {
    [Icon.name]: Icon,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [PullRefresh.name]: PullRefresh,
    ScanDialog
  },
  computed: {
    quickIconSize() {
      return Math.round(window.innerWidth * 72 / 1080)
    },
    headHeight() {
      return Math.round(window.innerWidth * 200 / 1080)
    },
    lastUpdateText() {
      const d = this.lastUpdate
      const now = new Date()
      let prefix = ''
      const yesterday = new Date(now)
      yesterday.setDate(now.getDate() - 1)
      if (d.toDateString() === now.toDateString()) {
        prefix = '今天'
      } else if (d.toDateString() === yesterday.toDateString()) {
        prefix = '昨天'
      } else {
        prefix = `${d.getMonth() + 1}月${d.getDate()}日`
      }
      const hh = String(d.getHours()).padStart(2, '0')
      const mm = String(d.getMinutes()).padStart(2, '0')
      return `${prefix} ${hh}:${mm}`
    }
  },
  data() {
    return {
      headerBg,
      scanVisible: false,
      showVerifyDialog: false,
      scrolled: false,
      refreshing: false,
      lastUpdate: new Date(),
      bannerList: [
        require('@/assets/banners/3f14f58d-88d7-4511-98ea-d55f6a407031.png'),
        require('@/assets/banners/b2682192-9ccf-419d-a217-76118f6b7a71.png'),
        require('@/assets/banners/4ea0b20a-675a-4cfa-8018-dba7f2ebbcce.png'),
        require('@/assets/banners/7452e6a0-5528-4aca-8e4c-7dfb51ee23e6.png'),
        require('@/assets/banners/6981ef64-98ef-4891-9f7c-343b2875ecdb.png')
      ],
      quickList: [
        { icon: 'scan', text: '扫一扫' },
        { icon: 'qr', text: '社保卡' },
        { icon: 'sign', text: '亮证' },
        { icon: 'todo-list-o', text: '办件' }
      ],
      appList: [
        { icon: 'app-card', text: '社保卡信息查询' },
        { icon: 'app-salary', text: '欠薪线索反映' },
        { icon: 'app-info', text: '基础信息核对' },
        { icon: 'app-skill', text: '专项职业能力证书查询' },
        { icon: 'app-computer', text: '全国计算机高新技术考试证书查询' },
        { icon: 'app-record', text: '用工备案信息查询' },
        { icon: 'app-all', text: '全部' }
      ],
      themeServices: [
        { icon: 'srv-social', title: '江苏省社保卡居民服务', desc: '居民服务' },
        { icon: 'srv-onething', title: '一件事专区', desc: '一件事专区' },
        { icon: 'srv-pension', title: '企业养老保险', desc: '资格认证|账户查询' },
        { icon: 'srv-map', title: '地图服务', desc: '地图服务' },
        { icon: 'srv-rural', title: '城乡居民养老保险', desc: '城乡居民服务' },
        { icon: 'srv-injury', title: '工伤保险', desc: '待遇支付|供养亲属' },
        { icon: 'srv-graduate', title: '毕业生就业掌上宝', desc: '高校毕业生|就业服务' },
        { icon: 'srv-socialcard', title: '社会保障卡', desc: '首次申请|正式挂失' },
        { icon: 'srv-elderly', title: '老年人专区', desc: '资格认证|待遇查询' },
        { icon: 'srv-legal', title: '法人专区', desc: '法人办理单位业务' },
        { icon: 'srv-unemploy', title: '就失业服务', desc: '失业登记|就业困难认定' },
        { icon: 'srv-training', title: '职业培训', desc: '培训报名|培训补贴' },
        { icon: 'srv-job', title: '求职招聘', desc: '找工作|招聘会查询' },
        { icon: 'srv-intern', title: '就业见习', desc: '见习岗位申请' },
        { icon: 'srv-skillcert', title: '职业技能鉴定', desc: '资格证书|专项能力证书' },
        { icon: 'srv-credit', title: '信用管理', desc: '职业技能培训和评价机构信...' },
        { icon: 'srv-labor', title: '劳动权益保障', desc: '劳动权益保障' }
      ]
    }
  },
  mounted() {
    // 实际滚动发生在 .page-container（App 外壳），在此监听以切换搜索栏底色
    this.scrollEl = this.$el.closest('.page-container')
    if (this.scrollEl) {
      this.scrollEl.addEventListener('scroll', this.onScroll, { passive: true })
      this.onScroll()
    }
  },
  beforeDestroy() {
    if (this.scrollEl) {
      this.scrollEl.removeEventListener('scroll', this.onScroll)
    }
  },
  methods: {
    onScroll() {
      // 头部背景高386w、搜索栏高约130w：背景底缘即将离开搜索栏时切换
      const threshold = window.innerWidth * 256 / 1080
      const val = this.scrollEl && this.scrollEl.scrollTop > threshold
      if (val !== this.scrolled) {
        this.scrolled = val
      }
    },
    getIcon(name) {
      return icons[name] || ''
    },
    handleQuickClick(item) {
      if (item.icon === 'scan') {
        this.scanVisible = true
      } else if (item.text === '社保卡') {
        Toast('未查询到您在本渠道的电子社保卡信息')
      } else if (item.text === '亮证') {
        // 亮证 → 亮证页（带loading）
        navigateWithLoading('/show-cert', 2000)
      } else if (item.text === '办件') {
        // 办件 → 我的办件（带loading）
        navigateWithLoading('/my-todo', 2000)
      }
    },
    handleAppClick(item) {
      if (item.text === '用工备案信息查询') {
        this.showVerifyDialog = true
        return
      }
      const routeMap = {
        '社保卡信息查询': '/social-card-query',
        '欠薪线索反映': '/salary',
        '基础信息核对': '/info-verify',
        '专项职业能力证书查询': '/skill-cert',
        '全国计算机高新技术考试证书查询': '/computer-cert',
        '全部': '/service'
      }
      const path = routeMap[item.text]
      if (path) {
        navigateWithLoading(path, 2000)
      }
    },
    goSearch() {
      navigateWithLoading('/search', 2000)
    },
    handleServiceClick(item) {
      const routeMap = {
        '企业养老保险': '/pension',
        '城乡居民养老保险': '/rural-pension',
        '工伤保险': '/injury',
        '社会保障卡': '/social-card',
        '一件事专区': '/one-thing',
        '地图服务': '/map-service',
        '毕业生就业掌上宝': '/graduate',
        '老年人专区': '/elderly',
        '江苏省社保卡居民服务': '/resident-service',
        '法人专区': '/legal-zone',
        '就失业服务': '/unemploy',
        '职业培训': '/training',
        '求职招聘': '/job-hunting',
        '就业见习': '/internship',
        '职业技能鉴定': '/skill-cert-list',
        '信用管理': '/credit-manage',
        '劳动权益保障': '/labor-rights'
      }
      const path = routeMap[item.title]
      if (path) {
        navigateWithLoading(path, 2000)
      }
    },
    handleScanSuccess(text) {
      Dialog.alert({
        title: '扫描结果',
        message: text
      })
    },
    handleVerifyConfirm() {
      this.showVerifyDialog = false
      // 二次认证确认逻辑
    },
    onRefresh() {
      // 模拟刷新请求，实际项目中替换为接口调用
      setTimeout(() => {
        this.lastUpdate = new Date()
        this.refreshing = false
      }, 1000)
    }
  }
}
</script>

<style scoped>
.home {
  position: relative;
  background: #f5f5f5;
  min-height: 100%;
}

/* 内容区：避开固定搜索栏（搜索栏高 112/1080） */
.home-body {
  padding-top: calc(112 * var(--w));
}

/* 下拉刷新提示（1080设计稿比例） */
.home-pull >>> .van-pull-refresh__head {
  background: #fff;
}
.rf-head {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: calc(24 * var(--w));
}
.rf-arrow {
  width: calc(56 * var(--w));
  height: calc(96 * var(--w));
  fill: none;
  stroke: #5f6368;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.rf-col {
  display: flex;
  flex-direction: column;
  gap: calc(16 * var(--w));
}
.rf-main {
  font-size: calc(44 * var(--w));
  color: #323233;
}
.rf-time {
  font-size: calc(32 * var(--w));
  color: #969799;
}
.rf-spinner {
  width: calc(64 * var(--w));
  height: calc(64 * var(--w));
  border: calc(6 * var(--w)) solid #e0e1e3;
  border-top-color: #0bb9cc;
  border-radius: 50%;
  animation: rf-rotate 0.8s linear infinite;
}
@keyframes rf-rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* 头部背景图：置于文档流顶部，随页面一起滚动，高386/1080 */
.header-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(386 * var(--w));
  background-size: 100% 100%;
  background-repeat: no-repeat;
  z-index: 0;
  pointer-events: none;
}

/* 下拉刷新容器置于背景层之上 */
.home-pull {
  position: relative;
  z-index: 1;
}

/* 搜索栏：固定顶部，透明背景（透出背景图） */
.search-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: transparent;
  padding: calc(16 * var(--w)) 0;
  display: flex;
  align-items: center;
  justify-content: center;
  /* 滚动后底色平滑淡入，避免突变 */
  transition: background 0.25s linear;
}
/* 头部背景滚走后：使用与背景图顶部一致的渐变底色，保证白色图标/文字可读 */
.search-bar.scrolled {
  background: linear-gradient(90deg, #388ed7, #39a1b6);
}
.search-container {
  width: 90%;
  height: calc(80 * var(--w));
  background: rgba(255, 255, 255, 0.22);
  border-radius: calc(4 * var(--w));
  display: flex;
  align-items: center;
  gap: calc(8 * var(--w));
  padding: 0 calc(24 * var(--w));
}
.loc-icon {
  width: calc(28 * var(--w));
  height: calc(28 * var(--w));
  flex-shrink: 0;
}
.loc-text {
  color: #fff;
  font-size: calc(34 * var(--w));
  white-space: nowrap;
}
.divider {
  width: 1px;
  height: calc(28 * var(--w));
  background: rgba(255, 255, 255, 0.5);
  margin: 0 calc(8 * var(--w));
  flex-shrink: 0;
}
.search-icon {
  width: calc(28 * var(--w));
  height: calc(28 * var(--w));
  flex-shrink: 0;
}
.placeholder {
  font-size: calc(34 * var(--w));
  color: rgba(255, 255, 255, 0.85);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 快捷功能（透明，透出背景图） */
.quick-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  background: transparent;
  padding: calc(62 * var(--w)) calc(24 * var(--w)) calc(72 * var(--w));
}
.quick-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: calc(18 * var(--w));
}
.quick-text {
  font-size: calc(44 * var(--w));
  color: #fff;
}

/* 应用图标区 */
.app-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  background: #fff;
  padding: calc(24 * var(--w)) calc(24 * var(--w)) calc(12 * var(--w));
  row-gap: calc(24 * var(--w));
}
.app-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: calc(20 * var(--w));
}
.app-icon {
  width: calc(82 * var(--w));
  height: calc(82 * var(--w));
  object-fit: contain;
}
.app-text {
  font-size: calc(35 * var(--w));
  line-height: calc(40 * var(--w));
  color: #323233;
  text-align: center;
  /* 允许长名称（如全国计算机高新技术考试证书查询）两行完整显示 */
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}

/* 轮播：白色整块，与上下区块以灰条分隔；图片90%居中 */
.banner {
  width: 100%;
  background: #fff;
  margin: calc(24 * var(--w)) 0;
  padding: calc(60 * var(--w)) 0 calc(50 * var(--w));
}
.banner-swipe {
  width: 90%;
  margin: 0 auto;
  border-radius: calc(16 * var(--w));
  overflow: hidden;
}
.banner-img {
  width: 100%;
  height: auto;
  display: block;
}

/* 主题服务（1080设计稿等比缩放） */
.theme-section {
  background: #fff;
  padding-bottom: calc(20 * var(--w));
}
.section-title {
  padding: calc(46 * var(--w)) 0 0 calc(41 * var(--w));
  margin-bottom: calc(52 * var(--w));
  font-size: calc(40 * var(--w));
  font-weight: bold;
  color: #f28100;
}
.service-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: calc(40 * var(--w)) calc(42 * var(--w));
  padding: 0 calc(41 * var(--w));
}
.service-item {
  position: relative;
  height: calc(175 * var(--w));
  background: #f5f8fd;
  border-radius: calc(8 * var(--w));
  overflow: hidden;
}
.service-icon {
  position: absolute;
  left: calc(19 * var(--w));
  top: calc(51 * var(--w));
  width: calc(44 * var(--w));
  height: calc(44 * var(--w));
  object-fit: contain;
}
.service-info {
  position: absolute;
  left: calc(104 * var(--w));
  top: calc(51 * var(--w));
  right: calc(20 * var(--w));
}
.service-title {
  font-size: calc(44 * var(--w));
  line-height: calc(44 * var(--w));
  color: #45464c;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.service-desc {
  margin-top: calc(28 * var(--w));
  font-size: calc(30 * var(--w));
  line-height: calc(30 * var(--w));
  color: #7c7d83;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 二次认证弹窗 */
.verify-dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
}
.verify-dialog {
  width: 80%;
  background: #fff;
  border-radius: calc(16 * var(--w));
  overflow: hidden;
}
.verify-title {
  padding: calc(48 * var(--w)) 0 calc(16 * var(--w));
  text-align: center;
  font-size: calc(40 * var(--w));
  font-weight: 500;
  color: #323233;
}
.verify-content {
  padding: 0 calc(48 * var(--w)) calc(48 * var(--w));
  text-align: center;
  font-size: calc(32 * var(--w));
  color: #323233;
}
.verify-btns {
  display: flex;
  border-top: 1px solid #f0f0f0;
}
.verify-btn {
  flex: 1;
  height: calc(96 * var(--w));
  font-size: calc(32 * var(--w));
  border: none;
  background: #fff;
  cursor: pointer;
}
.verify-btn.cancel {
  color: #969799;
  border-right: 1px solid #f0f0f0;
}
.verify-btn.confirm {
  color: #2E8CF6;
}
</style>





// WEBPACK FOOTER //
// src/pages/Home.vue